//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 详细配置规则请查看 README.md h5活动专题页
 **/
import config from 'config';
import action from './action';
import goodsList from './datas';
import {waterFalls} from 'components';
import { Cell,CellGroup } from 'vant';
import { RQ } from 'utils';
const business = { // 商家
  'E201805221004237724': {
    name: 'xzpq', // 小猪佩琦 测试商家
    "0618": '小猪佩琦测试h5活动', //活动名称
  },
  'E201805171149338247': {
    name: 'mshop', // mshop 生产环境测试商家
    "0618": 'mshop商家h5活动', //活动名称
  },
  'E201805211013467576': {
    name: 'xym', // 雪缘美
    "07211": '浴见惊喜  洗护狂欢', //活动名称
  },
  'E201904101244499369': {
    name: 'lr', // 领入
    "0721": '浴见惊喜  洗护狂欢', //活动名称
    "0618": '618狂欢购', //活动名称
    "0807": '浪漫七夕  优惠至上', //活动名称
    "0830": 'Pick 夏日元气彩妆', //活动名称
  },
  'E201901241550013545': {
    name: 'sly', // 诗丽雅
    "0719": '年中美丽盛宴', //活动名称
    "0810": '精选女人 │ 精选护肤', //活动名称
    "0830": 'Pick 夏日元气彩妆', //活动名称
  },
  'E201903251703063925': {
    name: 'flzw', // 弗兰之屋
    "0618": '618狂欢购', //活动名称
  },
  'E201805091153326581': {
    name: 'hx', // 海祥 邀请码 : 7813
    "0618": '618狂欢购', //活动名称
  },
  'E201904041712458032': {
    name: 'sqc', // 三仟彩美妆 邀请码 : 0939
    "0618": '618狂欢购', //活动名称
  },
  'E201904041645379110': {
    name: 'ys', // 悦诗化妆品  邀请码 : 1928
    "0618": '618狂欢购', //活动名称
  },
  'E201805091106398627': {
    name: 'sanshang', // 三商  邀请码 : 1981
    "0618": '618狂欢购', //活动名称
    "0723": '夏季补水  面膜优选', //活动名称
    "0818": '你开学  我放“价” 特价直降活动', //活动名称
  },
  'E201902181414506921': {
    name: 'shuaily', // 帅丽园   邀请码 : 3639
    "0618": '618狂欢购', //活动名称
  },
  'E201904241819548680': {
    name: 'dz', // 顶真化妆品  邀请码 : 5216
    "0618": '618狂欢购', //活动名称
  },
  'E201903251703063925': {
    name: 'sfl', // 诗芙兰
    "0830": 'Pick 夏日元气彩妆', //活动名称
  },
  'E201904101647423431':{//邀请码 :  2873
    name: 'shangmei', // 尚美
    "0903": '开学季 福利特惠购', //活动名称
  }

};

export default {
  name: 'activityPage',
  props: ['params'],
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  async created () {
    /**
     * @params
     *  enterpise || enterprise  商家编码 兼容之前拼错写法
     *  channel 分发渠道
     *  title 活动标题
     *  is_platform 是否是平台商家
     *  day 活动日期
     *  period 第几期活动
     **/
    const { enterpise, enterprise, token, channel, title, is_platform, day, period} = this.params;
    config.enterprise = enterpise || enterprise;
    config.token = token;
    this.channel = channel;
    this.day = this.getDay(day);
    this.period = period || 1;
    this.isInvalid = period === '0' || period === 0;
    this.enterprise = enterpise || enterprise;
    this.pageTitle = title !== 'undefined' && title !== 'null' && title ? Array.isArray(title) ? title[0] : title : `${business[enterprise][this.getDay(day)] || '夏日全方位清凉趴 暑促大放“价”'}`; //默认817的活动标题
    this.isPlatform = is_platform;
    console.log('paramsNo-----------------------------',G.member,G.member.paramsNo)
    // await this.getInfo();
    this.checkEnv();
  },
  async mounted() {
    const{ show_type,activityId } = this.params;
    const {paramsNo} = G.member || {};
    if(show_type == 1){// show_type:0或者null旧的h5前端写死的数据 1 请求后端h5活动数据 2:扫二维码请求预览数据
      const d = await RQ.mall.get('/api/h5/webpage/getWebpageData', {activityId,paramsNo:G.member.paramsNo}, { skipAuth: true,  enterprise: this.enterprise || '00'});
      if (d && d.code == 0) {
        this.pageData = d.data;
        this.dialogContent = d.msg;
        this.showActivityDialog = d.msg ? true :false;
      }
      else {
        this.tips(d.msg, 1500);
      }
    }else if(show_type == 2){//扫二维码
      const{ enterprise } = this.params;
      const d = await RQ.mall.get('/api/h5/webpage/getPreviewWebpageData', {paramsNo:G.member.paramsNo}, { skipAuth: true,  enterprise:enterprise?enterprise:this.enterprise || '00'});
      if (d && d.code == 0) {
        this.pageData = d.data;
      }else{
        this.tips(d.msg, 1500);
      }
    }else{
      this.generatePageData();
    }

    console.log('--------------mounted', this, config);
  },
  data() {
    return {
      enterprise: undefined,
      isPlatform: undefined,
      period: undefined,
      channel: undefined, // 渠道（1-微信公众号 2微信社区分享）
      info: {},
      appInfo: {}, // app信息
      pageTitle: undefined,
      day:undefined,
      business: business,
      pageData: [],
      goodsList: goodsList,
      salesGoods:{},
      showActivityDialog: false,//显示活动弹窗
      dialogContent:''
    };
  },
  computed: {},
  filters: {},
  components: {waterFalls,Cell,CellGroup},
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/app/activityPage/page.vue